import httpService from "../httpService";
import utils from "../utils";

export const vbIncomingDocUserTdhvpViewService = {
  findAll(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get("/vbIncomingDocUserTdhvpView", { params: params });
  },

  findById(id) {
    return httpService.get(`/vbIncomingDocUserTdhvpView/${id}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/tdhvp/vbIncomingDocUserTdhvpViewService.js